<script setup lang="ts">
import SiteHeader from '@/components/organisms/SiteHeader.vue'
import SiteFooter from '@/components/organisms/SiteFooter.vue'
</script>

<template>
  <div class="min-h-screen bg-ink text-snow">
    <SiteHeader />
    <main id="main-content"><slot /></main>
    <SiteFooter />
  </div>
</template>
